module.exports = __webpack_public_path__ + "img/emergency3.c24f0055.png";